"use client";
import {
  useCompositeGroup
} from "../__chunks/ZO6PSJHJ.js";
import "../__chunks/CWDOOAGR.js";
import "../__chunks/3X3MDQGM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/select/select-group.ts
var TagName = "div";
var useSelectGroup = createHook(
  function useSelectGroup2(props) {
    props = useCompositeGroup(props);
    return props;
  }
);
var SelectGroup = forwardRef(function SelectGroup2(props) {
  const htmlProps = useSelectGroup(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectGroup,
  useSelectGroup
};
